import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type DownloadBOLFactoryDependencies = {
  repository: ShipmentRepository
}

export function downloadBOLFactory({ repository }: DownloadBOLFactoryDependencies) {
  return async function download(uuid: string, config?: { signal?: AbortSignal }) {
    try {
      return await repository.downloadBOL(uuid, config)
    } catch (error) {
      throw new Error('Failed to download BOL', { cause: error as Error })
    }
  }
}

export function downloadBOL(id: string, config?: { signal: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const download = downloadBOLFactory({ repository })

  return download(id, config)
}
